import Settings from './Setting';
import CommonReducer from './CommonReducer';
import Auth from './Auth';
import ChatApp from './ChatApp';
import Courses from './Courses';

const reducers = {
  settings: Settings,
  auth: Auth,
  common: CommonReducer,
  chatApp: ChatApp,
  courses: Courses,
};

export default reducers;
